/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

export default function TableData() {


    const formCustomerRows = (data) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt?.name,
                address: dt?.address,
                phone: dt?.phone,
                country: dt?.country?.name
            });

        }
        return result
    }

    return {
        formCustomerRows,
        customerHeaders: [
            { Header: "Name", accessor: "name", align: "left" },
            { Header: "Address", accessor: "address", align: "center" },
            { Header: "Phone", accessor: "phone", align: "center" },
            { Header: "Country", accessor: "country", align: "center" }
        ],

    };
}
